export default "__VITE_ASSET__ba2536b9__"